import React from 'react';

type Props = {
    style?: React.CSSProperties;
};

const DashedDivider = (props: Props) => {
    return (
        <div
            style={{
                ...props.style,
                width: '100%',
                height: 2,
                backgroundImage: `url("/icons/dash.svg")`,
            }}
        />
    );
};

export default DashedDivider;
